import React, { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

export default function CalendarComponent({ initialFormattedDate, setinitialFormattedDate }) {
  // Initialize selectedDate with a valid date, or fallback to null if invalid
  const [selectedDate, setSelectedDate] = useState(
    initialFormattedDate ? dayjs(initialFormattedDate) : null
  );

  useEffect(() => {
    if (selectedDate && selectedDate.isValid()) {  // Check if selectedDate is valid
      console.log("selectedDate:", selectedDate.format("YYYY-MM-DD")); // Output date in YYYY-MM-DD format
      setinitialFormattedDate(selectedDate.format("YYYY-MM-DD"));
    }
  }, [selectedDate, setinitialFormattedDate]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 2 }}>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          value={selectedDate}
          onChange={(newValue) => setSelectedDate(newValue)} // Update state with the selected date
          openTo="day"
          showToolbar={false}
        />
      </Box>
    </LocalizationProvider>
  );
}
